/**
 * Resolve a theme token to the colour it currently stands for.
 *
 * Mapbox paint properties are handed to WebGL, not to CSS, so a `var(--…)`
 * reaches it as an unparseable string and the layer simply doesn't draw — which
 * is how the route arc went missing. Read the value off the document instead,
 * the same way the Stripe fields do for their iframe.
 *
 * The fallback covers the detached case (no document), and is the light-theme
 * value of the token so a map built before the stylesheet lands still draws
 * something rather than nothing.
 */
export function mapsTokenColor(name: string, fallback: string): string {
  if (typeof document === "undefined") return fallback;
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
  return value || fallback;
}
